import React from "react";

const SITE_URL = "https://mykcertifiedtranslations.com";
const DEFAULT_IMAGE = `${SITE_URL}/preview-image.png`;

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  noIndex = false,
  type = "website",
  children,
}) {
  const normalizedPath =
    path === "/" ? "/" : `/${String(path).replace(/^\/+|\/+$/g, "")}`;

  const canonicalUrl = `${SITE_URL}${normalizedPath}`;

  return (
    <>
      <title>{title}</title>

      <meta name="description" content={description} />

      <link rel="canonical" href={canonicalUrl} />

      <meta
        name="robots"
        content={
          noIndex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large"
        }
      />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="MYK Certified Translations" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {children}
    </>
  );
}